import { defineStore } from "pinia";

export const useAppHostStore = defineStore("appHostStore", {
    state: () => ({
        isEmbedded: false,
    }),
    actions: {
    },
})